import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="invoice-product-calculator"
export default class extends Controller {
  connect() {
    // Use event delegation to handle all inputs, including dynamically added ones
    this.element.addEventListener('input', this.handleInput.bind(this))
  }

  handleInput(event) {
    const input = event.target
    const fieldName = input.name
    
    // Only process qty and rate fields
    if (!fieldName || (!fieldName.includes('[qty]') && !fieldName.includes('[rate]'))) {
      return
    }
    
    // Find the parent field-duplicatee container
    const duplicatee = input.closest('[data-js="field-duplicatee"]')
    if (!duplicatee) return
    
    // Get all three fields
    const qtyInput = duplicatee.querySelector('input[name*="[qty]"]')
    const rateInput = duplicatee.querySelector('input[name*="[rate]"]')
    const amountInput = duplicatee.querySelector('input[name*="[amount]"]')
    
    if (!qtyInput || !rateInput || !amountInput) return
    
    // Calculate and update
    const qty = parseFloat(qtyInput.value) || 0
    const rate = parseFloat(rateInput.value) || 0
    const amount = (qty * rate).toFixed(2)
    
    amountInput.value = amount
  }
}

